import { Box, styled } from '@mui/material';

export const AlertBox = styled(Box)(() => ({
  display: 'flex',
  padding: '12px',
  borderRadius: '4px',
  fontSize: '14px',
  marginLeft: '16px',
  marginRight: '16px'
}));

export const InactiveAlertBox = styled(AlertBox)(({ theme }) => ({
  background: theme.palette.inactive.main,
  color: theme.palette.common.white,
}));

export const ErrorAlertBox = styled(AlertBox)(({ theme }) => ({
  backgroundColor: theme.palette.danger.main,
  color: theme.palette.common.white
}));

export const LightErrorAlertBox = styled(AlertBox)(({ theme }) => ({
  backgroundColor: theme.palette.backgroundDanger.main,
  color: theme.palette.dangerDark.main
}));

export const WarningAlertBox = styled(AlertBox)(({ theme }) => ({
  backgroundColor: theme.palette.warning.main,
  color: theme.palette.colorfef6e4.main
}));

export const SuccessAlertBox = styled(AlertBox)(({ theme }) => ({
  backgroundColor: theme.palette.success.main,
  color: theme.palette.colorc2f3ce.main
}));
